import { css } from "@emotion/react";

export const bold = css({
    fontWeight: 600,
});
